// extracted by mini-css-extract-plugin
export var header = "index-module--header--2rAS3";
export var leftText = "index-module--leftText--34pOd";
export var link = "index-module--link--VYQ2P";
export var word = "index-module--word--2mkMo";
export var pronunciation = "index-module--pronunciation--RDCJb";
export var definition = "index-module--definition--2Qs6i";
export var image = "index-module--image--32Sx6";